module.exports = __webpack_public_path__ + "img/db4f437.jpg";